// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../index';

import { CustomerRegistrationResponseFragmentDoc } from '../../../../auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../../../../auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../../../fragments/costumerConsultant.fragment.generated';
export const DesignStudioWeddingRingSuccessNewCustomerFragmentDoc = `
    fragment designStudioWeddingRingSuccessNewCustomer on CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer {
  customer {
    ...customerRegistrationResponse
  }
}
    `;